// extracted by mini-css-extract-plugin
export default {"contactsList":"StudentPersonalContacts_contactsList__q1IFS"};